// extracted by mini-css-extract-plugin
export default {"stock-request-report-container":"StockRequestReport_stock-request-report-container__PQjoM"};